import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";

// page for all routes that are currently being developed 
const UnderConstructionPage = () => {
    return (
        <div class='summary-page'>
            <HeaderBanner />
            <br/>
            <h1 style={{textAlign: 'center'}}>This Page Is Under Construction</h1>
            <br/>
            <Footer cssClassName="footer-main-comp"/>
        </div>
    );
}

export default UnderConstructionPage; 